import Flickity from "flickity";

const SELECTORS = {
  individualGameSteps:
    "#container--steps--embed .club__moments--individual-game",
};

window.Drupal.behaviors.individualGameSteps = {
  attach: (context) => {
    const ins = {};
    for (const instance in SELECTORS) {
      ins[instance] = [...context.querySelectorAll(SELECTORS[instance])];
      if (ins[instance].length) {
        for (const component of ins[instance]) {
          if (component.children.length > 1) {
            const flickity = new Flickity(component, {
              cellAlign: "center",
              // wrapAround: true,
              lazyLoad: true,
              contain: true,
              pageDots: true,
              adaptiveHeight: false,
              imagesLoaded: true,
              // prevNextButtons: false,
            });
          }
        }
      }
    }
    const pagePlayEmbed = document.querySelector("body.page-play-embed");
    const containerSteps = document.querySelector(
      "#club__moments--individual-game-steps"
    );
    const iframePlayClubEmbed = document.querySelector(
      "#iframe--play-club-embed"
    );
    // const theGame = document.querySelector(".the--game");
    // theGame.style.background = "transparent";

    if (pagePlayEmbed) {


      const goRanking =() => {
        location.href = '/ab-co-club-moments/ranking-third';
      }

      const changeBG = ()=> {
        iframePlayClubEmbed.style.backgroundColor  = "transparent";
      }
      const changeBGTo = ()=> {
        iframePlayClubEmbed.style.backgroundColor  = "#403022";
      }

      parent.goRanking = goRanking;
      parent.changeBG = changeBG;
      parent.changeBGTo = changeBGTo;

      const dotBtn = document.querySelectorAll(".dot");
      const nextBtn = document.querySelector(".flickity-prev-next-button.next");
      const saltarBtn = document.querySelector("#club__moments--individual-game-close-steps");
      const gameActions = document.querySelector(
        ".club__moments--individual-game-actions #club__moments--individual-game-close-steps"
      );
      
      const endDot = dotBtn[dotBtn.length - 1];
      dotBtn.forEach((e) => {
        nextBtn.disabled = false;
      });

      let count = 0;
      nextBtn.addEventListener("click", () => {
        nextBtn.disabled = false;
        if (count === 1) {
          showGame();
          count = 0;
        }
        if (endDot.classList.contains("is-selected")) {
          count = 1;
        }
      });

      gameActions.addEventListener("click", () => {
        showGame();
      });

      function showGame() {
        saltarBtn.style.display = "none";
        containerSteps.classList.add("iframe--active");
        iframePlayClubEmbed.classList.add("iframe--active");
      }
    }
  },
};

